var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z",
    fill: "url(#paint0_linear_72_1159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22193 10C8.0793 10 7.94493 10.0252 7.81775 10.077L10.365 12.7637L12.9405 15.4985L12.9875 15.5563L13.0627 15.6333L13.1379 15.7104L13.2883 15.8741L15.4971 18.1948C15.5339 18.2182 15.6405 18.3194 15.7237 18.362C15.831 18.4169 15.9473 18.4676 16.0671 18.4719C16.1964 18.4767 16.3286 18.4387 16.4449 18.3807C16.5321 18.3373 16.5708 18.2751 16.6721 18.1948L19.2287 15.4889L21.8136 12.7637L24.3044 10.1348C24.1445 10.046 23.9674 10 23.7781 10H8.22193ZM7.44178 10.3274C7.17013 10.5911 7 10.9875 7 11.4348V20.2556C7 20.6177 7.11355 20.9468 7.30078 21.1993L7.65796 20.8526L10.318 18.2044L12.6773 15.8644L12.6303 15.8067L10.0454 13.0815L7.46057 10.3467L7.44178 10.3274ZM24.6428 10.4141L22.1238 13.0815L19.5483 15.8067L19.5013 15.8548L21.9546 18.2911L24.6146 20.9393L24.7744 21.0933C24.9176 20.8579 25 20.5679 25 20.2556V11.4348C25 11.036 24.8651 10.6743 24.6428 10.4141ZM12.9781 16.1822L10.6282 18.5222L7.95875 21.1704L7.62037 21.5074C7.79876 21.6251 8.00177 21.7 8.22193 21.7H23.7781C24.0427 21.7 24.2828 21.5957 24.483 21.4304L24.3138 21.257L21.6444 18.6089L19.1911 16.1822L16.9822 18.5126C16.8627 18.5938 16.7828 18.6838 16.6661 18.7392C16.4782 18.8282 16.2723 18.9035 16.0653 18.9002C15.8578 18.8969 15.6543 18.8137 15.4681 18.7199C15.3746 18.6728 15.3248 18.626 15.2151 18.5319L12.9781 16.1822Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_1159",
    x1: 16,
    y1: 2.5,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5770FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70ECFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.45552a6ccda84e5154b3629f7df41d4a.svg";
export { ForwardRef as ReactComponent };